require('./pivot');



// WEBPACK FOOTER //
// ./node_modules/aframe/src/extras/components/index.js